export default class CarouselSlider {
    constructor() {
        const scrollContainer = document.getElementById('scrollCards');
        const dotsContainer = document.getElementById('carouselDots');

        if (!scrollContainer || !dotsContainer) {
            return;
        }

        const cards = Array.from(scrollContainer.children);
        if (!cards || cards.length === 0) {
            return;
        }

        const desktopQuery = window.matchMedia('(min-width: 992px)');

        let totalPages;
        initDots();

        function getCardsPerPage() {
            // Check for scroll-container-sm class for 2 cards on desktop
            if (desktopQuery.matches) {
                if (scrollContainer.parentElement.classList.contains('scroll-container-sm')) {
                    return 2;
                }
                return 3;
            }
            // Mobile and tablet: always 1 card per page
            return 1;
        }

        function countTotalPages() {
            const cardsPerPage = getCardsPerPage();
            const pages = Math.ceil(cards.length / cardsPerPage);
            return pages;
        }

        function drawDots() {
            dotsContainer.innerHTML = '';
            for (let i = 0; i < totalPages; i++) {
                const dot = document.createElement('span');
                dot.className = 'dot';
                if (i === 0) dot.classList.add('active');
                dot.addEventListener('click', () => {
                    let left;
                    const cardsPerPage = getCardsPerPage();
                    if (i === totalPages - 1) {
                        left = scrollContainer.scrollWidth - scrollContainer.clientWidth;
                    } else {
                        left = i * scrollContainer.clientWidth;
                    }
                    scrollContainer.scrollTo({
                        left,
                        behavior: 'smooth'
                    });
                    // Update active dot immediately
                    const dots = dotsContainer.querySelectorAll('.dot');
                    dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
                });
                dotsContainer.appendChild(dot);
            }
        }

        function initDots() {
            totalPages = countTotalPages();
            drawDots();
        }

        //Events
        scrollContainer.addEventListener('scroll', () => {
            const cardsPerPage = getCardsPerPage();
            let page = Math.round(scrollContainer.scrollLeft / scrollContainer.clientWidth);
            // If we're near the end, force last page
            if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 2) {
                page = totalPages - 1;
            }
            page = Math.max(0, Math.min(page, totalPages - 1));
            const dots = dotsContainer.querySelectorAll('.dot');
            dots.forEach((d, i) => d.classList.toggle('active', i === page));
        });

        desktopQuery.addEventListener('change', () => {
            totalPages = countTotalPages();
            drawDots();
            scrollContainer.scrollTo({ left: 0, behavior: 'instant' });
            const firstDot = dotsContainer.querySelector('.dot');
            if (firstDot) firstDot.classList.add('active');
        });

     
    }
}
